import React from 'react';
import MobileMenuTemplate from './template';

const MobileMenu = () => {
  return <MobileMenuTemplate />;
};

export default MobileMenu;
